import React from "react";
import styled from "styled-components";

import { Breadcrumbs } from "@examspark/common-app";
import { PDFDocument, VSpace } from "@examspark/common-ui";

import PageHead from "../../../../components/common/PageHead";
import PageTitle from "../../../../components/common/PageTitle";

const StyledDocument = styled.div`
  width: 100%;
  margin: 0 auto;
  height: 800px;
  flex: 1;

  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
`;

const TxRuralConference2025 = () => {
  return (
    <>
      <VSpace size="3rem">
        <PageHead>
          <Breadcrumbs items={Breadcrumbs.Dashboard()} />
          <PageTitle subtitle="Document">
            Texas Rural Schools Spring Conference
          </PageTitle>
        </PageHead>
        <StyledDocument>
          <div style={{ height: "70vh" }}>
            <PDFDocument url="https://examspark-app-files-master.s3.amazonaws.com/public/tcmpc/v10%20Rural%20Keynote%20Flyer%202025.pdf" />
          </div>
        </StyledDocument>
      </VSpace>
    </>
  );
};

export default TxRuralConference2025;
